module.exports = __webpack_public_path__ + "static/media/filled_bar_M2.9b10e649.svg";